<script lang="ts">
import { defineComponent, ref } from 'vue';
import { any } from 'vue-types';

export default defineComponent({
  name: 'Copy',
  props: {
    class: any(),
  },
  setup() {
    const year = new Date().getFullYear();
    const showHiddenTreasure = ref(false);
    return {
      showHiddenTreasure,
      year,
    };
  },
});
</script>

<template>
  <div :class="['mt-auto p-5', $props.class]">
    <div class="text-center opacity-50 relative">
      <FaIcon :icon="['fal', 'copyright']" />
      {{ year }}
      Produced by GradGuard
      <span class="relative inline-block align-baseline">
        <button
          type="button"
          class="10"
          @click="showHiddenTreasure = !showHiddenTreasure"
        >
          Tech
        </button>
        Team
        <span
          aria-hidden="true"
          class="absolute left-0 whitespace-nowrap transform transition-all duration-500 ease-out z-0 pointer-events-none"
          :class="showHiddenTreasure ? 'translate-x-0 opacity-100 left-20' : '-translate-x-full opacity-0'"
        >
          💰 Secret Treasure! 💰
        </span>
      </span>
    </div>
  </div>
</template>
